export default {
    welcome: '¡Bienvenido a Smartee.cn!',
    login: ' Iniciar sesión ',
    register: ' Registro',
    loginTitle: ' Página de inicio de sesión',
    registerTitle: ' Página de registro',
    forgetTitle: 'Olvidar contraseña ',
    mine: ' Mío ',
    username: 'Nombre de usuario ',
    password: ' Contraseña',
    conformPassword: ' Confirmar contraseña ',
    forget: ' Olvidar contraseña ',
    inputCount: 'Ingresar cuenta',
    mobile: ' Ingresar número de móvil ',
    refCode: ' Obtener código de verificación ',
    code: ' Código de verificación ',
    inputPassword: ' Ingresar contraseña ',
    inputConformPassword: 'Ingresar contraseña nuevamente',
    passwordlg6: ' ¡Contraseña no menos de 6 dígitos!',
    hascount: 'Cuenta existente',
    agreeIt: ' Marque "Aceptar el "Acuerdo de Registro de Usuario de Smartee"',
    verifynotise: 'Rellenar código de verificación',
    passwordSame: 'Misma contraseña',
    passwordDiff: '¡Contraseña inconsistente!',
    agree: ' Aceptar el "Acuerdo de Registro de Usuario de Smartee ',
    acount: ' Nombre de usuario ',
    surname: ' Apellido ',
    name: ' Nombre',
    sex: ' Sexo',
    male: ' Masculino ',
    female: 'Femenino ',
    contactNumber: ' Número de contacto',
    email: ' Correo electrónico',
    medicalInstitution: ' Nombre del hospital',
    zipCode: ' Código postal',
    hospitalAddress: ' Dirección del hospital',
    finish: 'Finalizar',
    save: ' Guardar',
    cancel: ' Cancelar',

    care: ' Seguir',
    undone: 'A tratar',
    unsubmit: 'A entregar',
    done: 'Tratando',
    finished: 'Finalizado',
    addPatient: ' Nuevo paciente',
    patientName: ' Nombre del paciente',
    productLine: 'Serie de productos',
    createTime: 'Fecha de crear',
    organizationName: ' Nombre del hospital',
    clinicalOperation: ' Operación clínica',
    caseProgress: 'Avance de caso',

    allResult: ' Todos los resultados',
    sex2: 'Sexo',
    yearold: 'Edad',
    qingkuang: ' Inspección',
    methods: 'Método de corrección',
    biaoje: 'Marca',
    all: ' Todos',
    femail: ' Masculino',
    mail: ' Femenino',
    features: ' Características',
    orthodonticTreatment: ' Método ortodóntico',
    caseStatus: 'Estado de caso',
    onlyready: 'Sólo ver',

    mangement: 'Gestión de casos',
    total: ' Estadísticas de casos',
    inputPatientName: ' Ingresar el nombre del paciente',
    scan: ' Escaneo bucal de un solo botón',
    zh: ' Chino simplificado Chinese',
    en: ' Inglés English',
    es: 'Español',
    fr: 'Francés',
    dashboard: 'Inicio',
    screenfull: ' Pantalla completa',
    size: ' Tamaño de diseño',

    messageType: ' Tipo de información',
    messageContent: 'Contenido de información',
    messageStatic: 'Estado de información',
    scanfile: 'Archivo de escaneo bucal',
    tooth: ' Diente',
    toothfile: ' Archivo de dientes',
    casestatus: 'Estado de caso',
    transferredcases: ' Caso ya transferido',
    transfernewcases: ' Caso nuevo transferido ',
    usescan: 'Iniciar el escaneo bucal de un solo botón de Smartee',
    smarteeusescan: ' Escaneo bucal de un solo botón de Smartee ',
    basemessage: ' Información básica ',
    selectionLines: ' Selección de serie de producto ',
    mismatchType: 'Tipo de maloclusión',
    photoUpload: 'Cargar fotos',
    otherPhotos: 'Otras fotos',
    xUpload: 'Cargar película de rayos x',
    caseform: 'Formulario de presentación de caso',
    submission: 'Presentar',
    storage: 'Guardar temporalmente',
    next: 'Siguiente',
    last: 'Atrás',
    patientMessage: 'Información del paciente',
    affiliatedHospital: 'Hospital afiliado',
    contactNumber: ' Número de contacto',
    receivingAddress: 'Dirección de recibo',
    productLine: 'Serie de producto',
    smartee1: 'Smartee GE Smartee',
    classicVersion: ' Versión clásica',
    smartee2: 'Smartee Pre+ extrema',
    prideEdition: ' Versión exclusiva',
    smartee3: 'Smartee U+ económica',
    youthVersion: ' Versión juvenil ',
    angletype: ' Tipo de angle ',
    mismatchtype: 'Tipo de maloclusión',
    faceLeft: ' Posición lateral de cara',
    faceLateral: ' Posición positiva de cara',
    faceSmile: ' Sonrisa de cara',
    upperDentition: ' Fila de dientes superiores ',
    lowerDentition: ' Fila de dientes inferiores ',
    rightImage: ' Imagen intraoral derecha',
    intraoralImage: 'Imagen intraoral positiva',
    leftImage: 'Imagen intraoral izquierda',
    photosDel: 'Poder cargar fotos a granel, hacer doble clic para eliminar',
    uploadPhotos: 'Cargar fotos',
    enterPhotoLocation: ' Ingresar la información de posición de foto',
    title: ' Información personal',
    phone: ' Teléfono',
    telephone: ' Teléfono fijo',
    city: 'Ciudad',
    quality: ' Certificado médico',
    info: ' Introducción',
    addressmanagement: ' Gestión de direcciones',
    setting: ' Configuración de seguridad',
    childcountsetting: ' Configuración de subcuenta',
    preferences: ' Preferencia clínica ',
    multipointPhysician: ' Multipunto de médico',
    IsCase: 'Derecho de caso',
    IsFinance: ' Derecho Financiero',
    casemanagement: 'Gestión de casos',
    casesStatistic: ' Estadísticas de casos',
    permission: ' Estadísticas de casos ',
    pagePermission: 'Seguir',
    directivePermission: 'A tratar',

    refresh: ' Actualizar',
    close: 'Cerrar',
    closeOthers: ' Cerrar otros',
    closeAll: ' Cerrar todos',
    angle1: 'Angle I',
    angle2: ' Angle II',
    angle3: ' Angle III',
    uncertain: ' Incierto',
    crowding: ' Atestado ',
    dentitionClearance: 'Espacio dental',
    Protrusion: ' Protrusión',
    openjaw: ' Mandíbula abierta',
    anteriorCrossbite: ' Mandíbula cruzada anterior',
    anterior: ' Dientes anteriores',
    rightTeeth: ' Dientes posteriores derechos',
    leftTeeth: ' Dientes posteriores izquierdos',
    posteriorCrossbite: ' Mandíbula cruzada posterior',
    deepCoverage: ' Cobertura profunda',
    deepOverbite: ' Sobreoclusión profunda',
    other: 'Otros',
    surfaceFault: ' Falla de curva',
    lateralCranium: ' Cráneo lateral ',
    uploadCBCT: 'Cargar CBCT',
    uploadFiles: 'Cargar archivos',
    choseModelFiles: ' Seleccionar el archivo de modelo digital',
    browse: 'Ver',
    otherXray: 'Cargar otras películas de rayos X',
    inputOtherXray: ' Ingresar la información de posición de película de rayos X',
    chiefComplaint: ' Queja principal',
    unevenTeeth: ' Dientes desiguales',
    diastema: ' Espacio dental',
    dentalProtrusion: ' Protrusión dental',
    dentofacialJaw: ' Mandíbula cruzada dental',
    majorObjectives: ' Objetivo de corrección mayor',

    arrangeTeeth: ' Arreglar dientes',
    closingDentitionSpace: ' Cerrar espacio dental',
    improvementProfile: 'Mejorar el perfil de protrusión',
    correctingJaw: ' Corregir mandíbula cruzada',
    orthodonticTeeth: ' Mandíbula dental a corregir',
    orthodonticsDescribe: ' Incluso para la corrección de una mandíbula, se requiere la impresión de goma de silicona de la mandíbula completa o el archivo digital',
    wholeJaw: ' Mandíbula completa',
    maxillary: ' Maxilar',
    mandible: ' Mandibular',
    toothInformation: ' Información de dientes',
    toothnotise: ' Nota: los dientes faltantes son grises, los deciduos son verdes. Si marca los dientes deciduos, deba elegir la radiografía.',
    noDeletion: 'Sin falta',
    noDeciduousTeeth: 'Sin dientes deciduos',
    deciduousTeeth: ' Dientes deciduos',
    teethmiss: 'Dientes faltantes',
    submitTeethModel: 'Presentar el molde de dientes',
    faceShape: 'Tipo de cara',
    siliconeRubberModel: ' Impresión de goma de silicona',
    siliconeRubberImpression: ' Molde de goma de silicona',
    siliconeRubberRecord: ' Registro oclusal de goma de silicona',
    courier: ' Número de expreso',
    courierNumber: 'Ingresar número de expreso',
    seachCourier: ' Ingresar el número de expreso, y presionar Enter para verificar la información de expreso, también poder hacer clic en el botón para realizarlo',
    courierNotise: ' Nota: enviar el número de envío con el molde para que el destinatario de Smartee lo verifique.',
    modelFiles: ' Archivo de molde digital',
    localFile: ' Archivo local',
    shape3: '3Shape/ Datos de escaneo bucal de Sinod',
    upload: 'Cargar',
    mattersNeedingAttention: ' Precauciones',
    saveSTL: ' El formato de guardar es STL;',
    includeScans: 'Debe contener registros de escaneo oclusal, maxilar y mandibular',
    includeZip: ' Cargar en forma comprimida (el tipo de archivo debe ser .rar / .zip).',
    shape: '3Shape',
    shape3web: ' Iniciar sesión en el sitio web de 3Shape',
    shape3user: ' Ingresar su nombre de usuario y contraseña de 3Shape',
    shape3qq: ' Agregar la cuenta de Smartee "48150554@qq.com", envíe los datos escaneados por TRIOS a esta cuenta',
    sinold: ' Datos de escaneo bucal de sinod',
    sinoldCount: ' Iniciar sesión en su cuenta de sinod',
    addSmarteeCount: 'Agregar la cuenta de Smartee "Smartee", envíe los datos escaneados a esta cuenta ',


    sendEmail: 'Poder enviar archivos zip, rar, stl a case@smartee.cn. Para el título del correo electrónico, escriba "Nombre del instituto + nombre del médico + nombre del paciente". ',
    patientDetails: 'Detalles del paciente',
    patientHome: 'Página de inicio del paciente',
    endTherapy: 'Terminar tratamiento',
    lateHolderShipped: 'Ya enviado el retenedor para período posterior',
    expressType: 'Tipo de expreso',
    chinaExpress: 'Expreso Zhongtong',
    sfExpress: ' Expreso Shunfeng',
    logisticsNumber: ' Número de logística',
    lateStageDelivery: 'Estimación de envío del retenedor para período posterior',
    endTreatmentConfirmed: 'Fin de tratamiento confirmado',
    laterStageHolderProcessing: 'Fabricando el retenedor para período posterior',
    estimatedDelivery: ' Estimación de envío del retenedor para período posterior',
    confirmationTreatment: 'Confirmar el fin de tratamiento',
    see: 'Ver',
    fineTuning: ' Ajuste fino',
    productionStage: ' Etapa de producción',
    delivery: 'Entrega',
    firstStage: ' Primera etapa',
    appliancesShipped: 'Ya enviado el alineador',

    totalMaxillarySteps: ' Pasos totales de maxilar',
    totalMandibularSteps: 'Pasos totales de mandibular',
    numberDeliverySteps: 'Pasos de este envío ',
    ShipmentForecast: 'Estimación de envío',
    FineTuningDesignConfirmed: 'Ya confirmado el diseño de ajuste fino',
    ProcessingFineTuned: 'Fabricando el alineador de ajuste fino',
    totalMaxillarySteps: 'Estimación de envío del alineador de ajuste fino',
    finelyAdjustDeliveryTime: ' Estimación de envío del alineador',
    designPhase: ' Etapa de diseño',
    design3D: ' Diseño 3D',
    confirmed: 'Ya confirmado',
    confirm: 'Confirmar',
    quotation: 'Oferta',
    receivingInspection: 'Inspección de recepción',
    checkQualified: 'Inspección calificada',
    unqualified: ' Inspección no calificada',
    modelReceived: 'Ya recibido el molde',
    fineTunedCasesSubmitted: 'Ya presentado el caso de ajuste fino',
    fineTunedCasesTobeSubmit: 'Caso de ajuste fino a presentar',
    fineTunedCasesStorage: ' Almacenamiento temporal del plan de ajuste fino',


    completeInformation: 'Datos a mejorar, completarla ',
    rearrangingTeeth: ' Reorganizar dientes ',
    ViewTooth: 'Ver reorganización de dientes',
    followUpConfirmed: 'Ya confirmada la solicitud posterior de procesamiento',
    followUpApplication: 'Ya solicitado el procesamiento posterior',
    followUptoComform: 'Procesamiento posterior a confirmar',
    followUpTime: 'Tiempo de estimación del procesamiento posterior del alineador',
    residualAppliance: 'Alineador restante',
    vice: 'auxiliar',
    designConfirmed: 'Ya confirmada la animación de diseño',
    clinicalDoctorsModifications: 'Modificaciones propuestas por los médicos clínicos ',
    tobeConfirmed: 'A confirmar',
    casesSubmitted: 'Ya presentado el caso',
    casesTobeSubmit: 'Caso a presentar',
    hospital: ' Hospital',
    caseCharacteristics: 'Características del caso',
    impactData: ' Datos de imagen',
    group: 'Grupo',
    caseInformation: ' Datos del caso',
    proceduresStage: ' Requerir práctica clínica en esta etapa',
    fineAdjustment: 'Ajuste fino',
    processingFollowUp: 'Procesamiento posterior',
    finelyTunedCaseSubmissionForm: ' Formulario de entrega del caso de ajuste fino',
    currentAppliancesFit: ' Situación de aplicación del alineador actual',
    applianceFit: ' Aplicación del alineador',
    judgementBasis: ' Base de juicio: el movimiento de los dientes y la relación oclusal son básicamente consistentes con el diseño del alineador simulado, y no hay un espacio evidente entre el alineador y los dientes.',
    appliancesUnfit: 'Alineador vagante',
    needmodelfile: ' Requerir una impresión de goma de silicona de boca completa o un archivo de molde digital de boca completa.',
    defaultGrind: ' Moler todos los accesorios en la salida antes de retirar la silicona; si no se muele, nuestra empresa lo trata de manera predeterminada como la molienda.',
    clinicalExamination: ' Examen clínico',
    orthodonticSteps: 'El número de pasos para usar el alineador en esta retroalimentación es:',
    isDentitionSpace: 'Si hay espacio dental',
    none: 'No hay',
    have: 'Hay',
    left: 'Izquierda',
    right: 'Derecha',
    clearanceCheck: 'Verificar el espacio dental actual (medir con precisión con el calibre de espacio): nota: el espacio es de hasta 2 decimales, con unidad mm',
    otherCheck: ' Otras inspecciones (incluyendo desalineación de dientes, aflojamiento, grado de contacto temprano, etc.)',


    otherLimited: 'En otros casos, limitarlo a 1000 palabras (después de una eliminación accidental, usar Ctrl + z para cancelar la operación).',
    designRequirement: 'Requisitos de diseño de la etapa anterior (si hay un cambio, avisar al médico para ajustar a tiempo, si no se modifica, la empresa continuará los requisitos de diseño de la etapa anterior)',
    NonRemovableTeeth: ' Dientes no movibles',
    NonRemovableTeethType: ' (dientes de porcelana, reparación de puentes, dientes implantados, y otros dientes no movibles)',
    followingTeethImmovable: ' Los siguientes dientes no se pueden mover',
    notDesigned: ' Dientes que no se pueden diseñar los accesorios',
    notDesignedType: ' Los dientes de porcelana y la reparación de puentes, etc. no se pueden unir al accesorio',
    NonRemovableDesign: ' Los siguientes dientes no se pueden diseñar los accesorios',
    FlatGuidePlateTeeth: ' Placa guía plana del diente frontal',
    suitableCase: ' Caso adecuado con cobertura superficial oclusal profunda',
    anteriorCentralIncisor: 'Dientes incisivos centrales en el frontal',
    LateralIncisorsAnteriorTeeth: 'Dientes incisivos laterales en el frontal',
    anteriorTeeth: ' Colmillo frontal',
    longDistanceTreatment: 'Si corrección remota',
    selectYes: ' ota: Si marca sí, se va a fusionar todas las operaciones clínicas en el primer paso durante el primer diseño de 3D',
    yes: 'Sí',
    no: 'No',
    cover: ' Cubierta',
    isCommunicate: ' Si realizar la comunicación de programa con el departamento médico de Smartee',
    every3mothsVisit: ' Cita cada 3 meses',
    every6mothsVisit: ' Cita cada 6 meses',
    every12mothsVisit: ' Cita cada 12 meses',
    secondVisit: 'Una vez de cita',
    unableDetermineReferralPeriod: 'No poder determinar el período de cita',
    followUpOrthodontic: 'Requisitos de corrección posterior (no deber cambiar el objetivo de corrección inicial)',
    limited: ' Ingresar menos de 1000 palabras',
    unfitPhotographs: 'Foto de la parte donde el alineador no encaja',
    unfit: ' Vagante',
    images: 'Imagen',
    photographs: ' Fotografía bucal',
    photoface: ' Fotografía de cara',

    wholeJaw: ' Radiografías de curva de la mandíbula completa',
    cephalometric: ' Película de posicionamiento lateral craneal',
    unsubmit: 'No presentar',

    submitDataModel: ' Presentar el molde digital completo y claro',
    viewingModelRequirements: 'Ver requisitos de molde',
    boxScanFile: ' Archivo de escaneo de caja',
    saveSTL: 'El formato de guardar es STL',
    scanList: 'Deber contener el registro de escaneo oclusal',

    doctorSignature: 'Firma del médico',
    date: 'Fecha',
    completionOrthodonticTreatment: 'Situación de terminación de corrección',
    whichBelongs: 'Confirmar el tipo de terminación',
    achievingCorrectionObjectives: 'Lograr objetivos correctivos',
    changeOtherMethods: 'La corrección invisible logra el efecto de etapa, y se utiliza otros métodos de corrección para completar',
    unfinishIquiredOver: 'No lograr objetivos de corrección invisible, pero el paciente requiere terminarla',
    inputOthers: 'Completar el cuadro de entrada por otras razones',
    finishedPhotos: 'Foto después de terminar el tratamiento de corrección',
    postWarrantyData: 'Datos de post-garantía',
    letterAuthorization: ' Carta de autorización',
    currentPatientName: 'Nombre del paciente actual',
    hospital: 'Hospital',
    clinic: 'Clínica',
    letterSmartee: 'Aceptar la Carta de autorización de terminación de corrección invisible',

    letterPrint: ' Imprimir Carta de autorización de terminación de corrección invisible ',
    canvasDesign: ' Diseño de animación',
    canvasView: 'Ver animación',
    gums: ' Encía',
    workSpace: ' Cara de trabajo',
    occlusion: ' Oclusión',
    contrast: 'Comparación',
    occlusion: ' Oclusión',
    enclosure: ' Accesorios',
    grid: ' Cuadrícula',
    designCommunication: ' Comunicación de diseño',
    distributionInformation: ' Información de distribución',
    operation: 'Descripción de operación',
    inputEdit: ' Ingresar sus comentarios sobre modificación aquí',
    agreeProgramme: 'Presionar el botón de aprobación en la esquina superior derecha para aceptar el programa de corrección',
    mockProgramme: 'Programa de simulación',
    effectDifferent: ' El efecto del tratamiento real puede ser diferente',
    animationContrast: 'Comparación de animación',


    transferCases: ' Guardar y transferir nuevos casos',
    scanRescan: 'Escaneo bucal nuevo de Smartee ',
    checkMouth: 'Ver escaneo bucal ',
    mk: 'MK',
    mainPages: ' Interfaz principal',
    UnderTenyears: ' Menores de 10 años',
    from10to20: ' 10 -20 años',
    from21to30: ' 21 -30 años',
    from31to40: ' 31 -40 años',
    over41: ' 41 años y mayores',

    interproximalEnamelStripping: ' Pelado interproximal del esmalte',
    distalMolars: 'Molar distal',
    classTraction: 'Tracción tipo II / III',
    extendedAnteriorTeeth: ' Dientes anteriores extendidos',
    lowerFrontTeeth: ' Bajar los dientes anteriores',
    archExpansion: ' Expansión palatina',
    pressDown: 'Bajar dientes anteriores y levantar molares anteriores',
    lipMoveUp: ' Dientes anteriores superiores con labios desplazados',
    tongueMovedown: 'Dientes anteriores superiores con lengua desplazada',
    maxillaryAnteriorTeeth: 'Extensión de los dientes anteriores maxilares',
    mandibleAnteriorTeeth: 'Extensión de los dientes anteriores mandibulares',
    improveMidline: 'Mejorar línea media',
    midline: ' Línea media',
    improvementMaxillaryProtrusion: ' Mejorar la Protrusión maxilar',
    improvementMaxillaryRetraction: ' Mejorar la retracción maxilar',
    improvementMandibularProtrusion: ' Mejorar la Protrusión mandibular',
    improvingMandibularRetraction: ' Mejorar la retracción mandibular',
    sagittalRelationship: ' Relación sagital',
    allJawSilicone: ' Incluso para la corrección de una mandíbula, se requiere la impresión de goma de silicona de la mandíbula completa o el archivo digital',
    improve: 'Mejorar',
    maintain: 'Mantener',
    firstChoice: ' Primera elección',
    optional: ' Opcional',
    notAllowed: ' No permitido',
    rightUpper: ' Derecha superior',
    leftUpper: ' Izquierda superior ',
    xRayRequired: 'Nota：Si marca, la radiografía es obligatoria',
    maintainingImprovingRelationship: 'Mantener la relación dental mejorada',
    caninesMolars: ' Mejorar la relación entre colmillos y molares',
    adjustmentNeutrality: 'Ajustar a la relación neutral',
    moreAdjacentGlazing: 'Es posible requerir más pelado interproximal del esmalte o extracción de dientes',

    maintainMidline: ' Mantener la línea media',
    maybeRequerEnamelStripping: '(Es posible requerir pelado interproximal del esmalte)',
    righttoPatient: ' A la derecha del paciente',
    lefttoPatient: ' A la izquierda del paciente ',
    correctionGap: ' Corrección de espacio',
    increaseDesigns: 'Es posible aumentar el tiempo de modificación y el número de diseños de 3D',
    righttoPatient: ' A la derecha del paciente',
    noSpaceReserved: ' No reservar espacio',
    spaceReserved: ' No reservar espacio',
    adduction: ' Aducción de dientes anteriores',
    NearPosteriorTooth: 'Movimiento cercano de dientes posteriores',
    lipTilt: ' Inclinación de labios',
    toothExtraction: ' Extracción de dientes',
    notoothExtraction: 'No extracción de dientes ',
    correctionCrowding: 'Corrección de diente atestado',
    followingTeeth: ' Extraer siguientes dientes ',
    sign: 'Marca',
    methods: ' Método',
    intermaxillaryTraction: 'Necesitar cooperar con la tracción intermaxilar',
    caseBank: 'Base de casos',
    financialManagement: ' Gestión financiera',
    marketActivity: ' Actividad de mercado',
    messageNotification: ' Notificación de información',
    messageDetail: ' Detalles de información',
    wornOut: 'El alineador está a punto de llevar acabado',
    canvasModified: 'Ya modificado el programa de animación',
    fixedTel: ' Teléfono fijo',
    definition3Ddesign: 'Determinar después del diseño',
    othersSpecified: ' Otros (indicar en descripciones especiales)',
    openOcclusion: ' Corregir los dientes abiertos',
    deepOverbite: ' Corregir la oclusión profunda',
    overbite: 'Sobreoclusión',
    backtop: ' Volver arriba',
    anteriorTeeth: ' Sólo bajar los dientes anteriores ',
    receiveName: ' Destinatario',
    region: ' Región',
    addressDetail: ' Dirección detallada',
    telphone: ' Contacto',
    default: ' Predeterminado',
    invoiceAddress: ' Dirección de correo de factura',
    securitySetting: ' Configuración de seguridad',
    loginPassword: ' Contraseña de inicio de sesión',
    verifyphone: ' Verificar teléfono',


    anteriorTeeth: ' Mandíbula opuesta de dientes anteriores',
    anteriorCrossbite: ' Mandíbula cruzada de dientes anteriores',
    posteriorTeeth: ' Dientes posteriores oclusales o entrelazados (si existe)',
    addSubaccounts: 'Agregar subcuenta',
    subaccountName: ' Nombre de usuario de subcuenta',
    hospitalname: ' Nombre del hospital',
    access: ' Derechos de acceso',
    availability: ' Disponibilidad',
    notRectify: ' No corregir',
    rectify: 'Corregir',
    designmanage: ' Gestión del diseño',
    designValidation: ' Confirmar diseño, compartir diseño, proponer opiniones de comunicación',
    treatmentManage: 'Gestión del tratamiento',
    editcase: ' Editar formulario de entrega de caso, confirmar recibo, terminar tratamiento',
    sheetView: 'Ver oferta',
    maybe: 'Si está bien',
    specialInstructions: 'Descripciones especiales',
    wisdomTooth: ' Muela cordal',
    defaultRemoval: ' Extracción predeterminada (el aplicador no cubre)',
    requirements: ' De acuerdo con los requisitos del programa',
    glazeRemoval: ' Pelado del esmalte',
    glazeRemovalPositon: 'Posición de pelado del esmalte',
    frontTeethFirst: ' Prioridad de dientes anteriores',
    posteriorTeethPreferred: ' Prioridad de dientes posteriores',
    beautifulDentition: ' Dentición hermosa',
    unwanted: ' No es necesario',
    need: ' Necesario cuando el espacio en la región anterior es mayor que 4 mm',
    attachment: ' Operación y pegado de anexo',
    doing: 'Haciendo',
    DelayStep: ' Aplazado a',

    systemhelp: ' Ayuda del sistema',
    tips: ' Consejos',
    consultation: ' No ha instalado el software de escaneo bucal Smartee, ¡póngase en contacto con el servicio al cliente o con el departamento de ventas para consultar!',
    feeConfirmationForm: ' Confirmación de tarifa para corrección invisible sin corchete de Smartee',
    back: 'Volver',
    specificationTable: ' Tabla de descripción',
    confirmationAgreement: ' Confirmar acuerdo',
    scanApp: 'Escanear para descargar la aplicación móvil de corrección invisible de Smartee',

    clickzoom: ' Hacer clic en la foto para ampliar',
    semail: 'Enviar correo',
    fineTuned: 'Fabricando el alineador',
    followTitle: ' Procesamiento posterior',
    deliveryTotal: 'Etapa de entrega',
    total: 'Total',
    this: 'Solicitud de esta vez',
    deliveryTime: 'Tiempo de estimación de solicitud de la siguiente entrega',
    fineTunedCases: 'Caso de ajuste fino',
    submitted: 'Ya presentado',
    tobeSubmit: 'A presentar',
    clickUpload: 'Hacer clic para modificar',
    secret: ' Confidencial',
    edit: ' Editar',
    add: 'Agregar',
    isDefault: ' Si es predeterminado',

    requiredPhone: ' Número de teléfono requerido',
    requiredPhone11: ' Número de teléfono requerido con dígitos no menos de 11',
    requiredRightPhone: 'Ingresar el número de teléfono correcto',

    requiredPassword: 'Contraseña requerida',
    requiredPasswordLg6: 'Contraseña requerida con dígitos no menos de 6',

    requiredCode: ' Código requerido',
    requiredCodelg6: 'Código requerido con dígitos hasta 6',

    errorSubmit: ' ¡Error de envío!',
    sendSuccess: ' ¡Enviar con éxito! Recibir',
    sendError: '¡Enviar sin éxito! Volver a enviar',
    resetPassword: 'Restablecer contraseña',
    requiredEmail: 'Ingresar la dirección de correo electrónico correcta',
    logOut: 'Salir',
    choose: 'Seleccionar',
    introduction: 'Introducción',
    baseInfo: 'Datos básicos',
    city: 'Ciudad',
    oldPassword: 'Contraseña antigua',
    newPassword: 'Nueva contraseña',
    changeSuccess: 'Modificar con éxito',
    checkPass: 'Confirmar contraseña',
    oldphone: 'Número de teléfono antiguo',
    newphone: ' Nuevo número de teléfono',
    oldCode: ' Número de teléfono antiguo',

    Name: 'Nombre',
    editRow: 'Operación',
    addInvoiceAddress: 'Agregar dirección de correo de factura',
    addAddress: ' Agregar dirección de recibo',
    editInvoiceAddress: 'Modificar dirección de correo de factura',
    editAddress: ' Modificar dirección de recibo',
    inputHospitalAddress: ' Ingresar nombre del hospital ',
    inputHospitalAddress: ' Ingresar dirección del hospital',
    casesn: ' Número de serie',
    casecode: ' Número',
    age: 'Edad',
    rightdown: ' Derecha inferior',
    leftdown: 'Izquierda inferior',
    over2m: ' Más de 2m',
    isrequerdtosmartee: ' Si realizar la comunicación de programa con el departamento médico de Smartee',
    isMSGRead: ' Leído',
    isMSGunRead: 'A leer',
    sysNotise: ' Aviso del sistema',
    processNotise: ' Aviso del avance',
    stepsNotise: ' Aviso de etapa',
    patientGender: ' Seleccionar la etapa',
    inputpatientAge: ' Ingresar la edad',
    inputHospitalName: ' Ingresar el nombre del hospital',
    filetyps: 'Cargar como un paquete comprimido (el tipo de archivo debe ser .rar / .zip)'
    
}


// WEBPACK FOOTER //
// ./src/lang/es.js